const FREEBLOCK_SERVICES = {};

export function registerService(name, obj) {
  FREEBLOCK_SERVICES[name] = obj;
}

export function getService(name) {
  return FREEBLOCK_SERVICES[name];
}

